module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-29.663670a1.svg";